import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
export { HomePage } from './pages/HomePage';
export { AboutPage } from './pages/AboutPage';
export { ShippingPage } from './pages/ShippingPage';
export { PrivacyPage } from './pages/PrivacyPage';
export { SitemapPage } from './pages/SitemapPage';
export { ModelChartsPage } from './pages/ModelChartsPage';
export { CareersPage } from './pages/CareersPage';
export { ContactPage } from './pages/ContactPage';
render(<App data-id="element-515" />, document.getElementById('root'));